import React from 'react';
import { CheckCircle2, Circle, Loader2 } from 'lucide-react';
import { Card, SectionTitle } from './MlmShell';

const icons = { pendiente: Circle, en_curso: Loader2, completado: CheckCircle2 };
const next = { pendiente: 'en_curso', en_curso: 'completado', completado: 'pendiente' };

export const MlmActivation = ({ workspace, api }) => {
  const { tasks, metrics } = workspace;
  const phases = ['Diagnóstico', 'Activación'];
  return (
    <Card testId="mlm-activation-panel">
      <SectionTitle kicker="Diagnóstico + Activación 369" title={`Plan de 7 días · ${metrics.activation_progress}%`} subtitle="Analizamos procesos, herramientas y cuellos de botella para saber qué automatizar primero y cómo obtener retorno real. Valor en 3-7 días." />
      <div className="mt-4 h-2 overflow-hidden rounded-full bg-slate-100"><div className="h-full rounded-full bg-[#E2001A] transition-all" style={{ width: `${metrics.activation_progress}%` }} /></div>
      <div className="mt-6 grid gap-6 lg:grid-cols-2">
        {phases.map((phase) => (
          <div key={phase}>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#0B3F8C]">{phase}</p>
            <ul className="mt-3 space-y-2">
              {tasks.filter((t) => t.phase === phase).map((t) => {
                const Icon = icons[t.status] || Circle;
                return (
                  <li key={t.id}>
                    <button type="button" onClick={() => api(`/tasks/${t.id}`, { method: 'PATCH', body: JSON.stringify({ status: next[t.status] || 'en_curso' }) }, { success: 'Tarea actualizada', key: `task-${t.id}` })}
                      className={`flex w-full items-start gap-3 rounded-2xl border px-4 py-3 text-left text-sm transition ${t.status === 'completado' ? 'border-emerald-200 bg-emerald-50' : t.status === 'en_curso' ? 'border-[#0B3F8C]/30 bg-[#f1f5fb]' : 'border-slate-100 bg-white hover:border-[#0B3F8C]/30'}`}
                      data-testid={`mlm-task-${t.id}`}>
                      <Icon className={`mt-0.5 h-4 w-4 shrink-0 ${t.status === 'completado' ? 'text-emerald-600' : t.status === 'en_curso' ? 'text-[#0B3F8C] animate-spin' : 'text-slate-300'}`} />
                      <span><span className={`font-semibold ${t.status === 'completado' ? 'text-emerald-800 line-through' : 'text-slate-800'}`}>{t.title}</span><span className="block text-xs text-slate-500">Día {t.day} · {t.owner}</span></span>
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
    </Card>
  );
};
